import React, { useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import * as moment from 'moment'
import ReactTooltip from 'react-tooltip'
import { useDispatch, useSelector } from 'react-redux'
import { MoonLoader } from 'react-spinners'

import { changeOverviewFilter, resetOverviewClients, retrieveOverviewClients } from '../../../../../redux/actions/overview'
import percentDiff from 'percentage-difference' 
import './style.scss'

const Index = () => {

	const dispatch = useDispatch()

	const filter = useSelector(state => state.overview.filters.clients)
	const loading = useSelector(state => state.overview.fetchClients.loading)
	const userLoading = useSelector(state => state.user.fetchUserDetails.loading)
	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

	const {current, previous} = useSelector(state => state.overview.fetchClients.status)

	useEffect(() => {

		if(!userLoading){
			if(selectedCompany){
				if(!filter){
					dispatch(resetOverviewClients())
					const start = moment(Date.now()).subtract({day: 7}).unix()
					const end = moment(Date.now()).set({hour: 23, minute: 59, second: 59}).unix()
					dispatch(changeOverviewFilter({type: "clients", filter: {name: "week", range: {start: start, end: end}}}))
				} else {
					dispatch(retrieveOverviewClients({filter: filter, companyId: selectedCompany}))
				}
			} else {
				dispatch(resetOverviewClients())
			}
		}

	}, [selectedCompany, filter, userLoading])

	//percentDiff(previous.length, current.length, true)

	const renderTrend = value => {
		if(value){
			if(value > 0){
				return 'uptrend'
			} else if(value < 0){
				return 'downtrend'
			}
		} else {
			return 'none'
		}
	}

	const renderDisplay = value => {
		if(value){
			return(
				<span data-tip="Sammenlignet med forrige tidsperiode." data-html={true} data-class="tooltip-hover" className={`statistics-performance ${renderTrend(value)}`}>
					{value > 0 ? <i class="fas fa-arrow-up"></i>:<i class="fas fa-arrow-down"></i>} {Math.abs(value)}%
				</span>
			)
		}
	}

	const calculateChange = () => {
		if(current && previous){
			if(current.length > 0 && previous.length > 0){
				return renderDisplay(percentDiff(previous.length, current.length, true))
			} else {
				if(current.length > 0 && previous.length === 0){
					return renderDisplay(current.length * 100)
				} else if(previous.length > 0 && current.length === 0){
					return renderDisplay(previous.length * 100)
				}
			}
		}
		return <span data-tip="Sammenligning ikke mulig." data-html={true} data-class="tooltip-hover" className={`statistics-performance`}><i class="fas fa-minus minus-icon"></i></span>
	}

	const renderAmount = () => {
		if(!loading && selectedCompany && current){
			if(current.length > 0){
				return current.length
			} else {
				return 0
			}
		} else {
			if(!loading && !selectedCompany && !current){
				return 0
			} else {
				return <MoonLoader size={18} color={"#123abc"} loading={true}/>
			}
		}
	}

	return(
		<div className="clients-details-container">
			<Row className="my-auto">
				<Col className="text-left">
					<h4 className="statistics-title">{renderAmount()}</h4>
				</Col>
				<Col className="text-right">
					{!loading && calculateChange()}
				</Col>
			</Row>
			<ReactTooltip id="clientsTooltip" html={true}/>
		</div>
	)
}

export default Index
